module.exports = __webpack_public_path__ + "static/goldseker-logo-black-5aa233b9a26454cdb311ada60da7ba22.png";